import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

export const Review = ({
  authorImagePosition,
  isLayout4,
  cardAnimationClass,
  reviewStyles,
  testimonialData,
  headlineStylesFromConfig,
  reviewStylesFromConfig,
  textAlignmentStyle,
  isMobile,
  listPresentationConfig,
}) => {
  const { review, headline } = testimonialData;

  const [isReviewClamped, setReviewIsClamped] = useState(false);
  const [expandReview, setExpandReview] = useState(false);
  const textContainerRef = useRef(null);

  function shouldAdjustReviewLineHeight() {
    const { numColumnsMobile, numColumnsDesktop } = listPresentationConfig || {};
    const numColumns = isMobile ? numColumnsMobile : numColumnsDesktop;
    return numColumns === 1;
  }

  useEffect(() => {
    checkTextClamping();
    window.addEventListener('resize', checkTextClamping);

    return () => {
      window.removeEventListener('resize', checkTextClamping);
    };
  }, [review.length, textContainerRef.current]);

  function checkTextClamping() {
    if (textContainerRef.current) {
      const isTextClamped =
        textContainerRef.current.scrollHeight > textContainerRef.current.clientHeight;
      setReviewIsClamped(isTextClamped);
    }
  }

  function getLineClampClass() {
    return isLayout4 ? 'tw-line-clamp-2' : 'tw-line-clamp-5';
  }

  return (
    <div
      className={classNames(
        'tw-flex tw-max-w-[1000px] tw-flex-grow tw-flex-col tw-gap-[12px]',
        authorImagePosition.top ? '!tw-gap-[12px]' : '',
        isLayout4 ? cardAnimationClass : ''
      )}
      style={reviewStyles}
    >
      {!!headline?.trim() && (
        <p
          className="tw-m-0"
          style={{ ...headlineStylesFromConfig, ...textAlignmentStyle }}
        >
          {headline}
        </p>
      )}
      <div
        style={{
          ...reviewStylesFromConfig,
          ...(shouldAdjustReviewLineHeight() ? { lineHeight: 1.6 } : {}),
          ...textAlignmentStyle,
        }}
      >
        <p
          ref={textContainerRef}
          className={classNames('tw-m-0', !expandReview ? getLineClampClass() : '')}
        >
          {review}
        </p>
        {isReviewClamped && (
          <span
            className="tw-mt-[2px] tw-cursor-pointer tw-font-semibold"
            style={textAlignmentStyle}
            onClick={() => setExpandReview(!expandReview)}
          >
            {!expandReview ? 'Read more' : 'Read less'}
          </span>
        )}
      </div>
    </div>
  );
};
